var map = {
	"./ar.json": [
		5235,
		5235
	],
	"./en.json": [
		8083,
		8083
	],
	"./fr.json": [
		8464,
		8464
	],
	"./ru.json": [
		7501,
		7501
	],
	"./tr.json": [
		6766,
		6766
	],
	"./zh.json": [
		7210,
		7210
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7146;
module.exports = webpackAsyncContext;